<template>
    <div class="icons-container">
        <v-btn
            v-for="socialLink in socialLinks"
            :key="socialLink.icon"
            variant="text"
            :icon="socialLink.icon"
            :href="socialLink.url"
            target="_blank"
        />
    </div>
</template>

<script lang="ts">
    import {Component, Vue} from 'vue-facing-decorator'

    @Component
    export class SocialIcons extends Vue {
        /**
         * For vk, x-twitter, tiktok need to add Font Awesome stylesheet in nuxt config and vk value for custom vuetify options
         * @returns {{icon: string, url: string}[]}
         */
        get socialLinks() {
            return cmsStore.layoutSettings.socialLinks.map(({icon, url}) => {
                icon = (['vk', 'tiktok', 'x-twitter'].includes(icon) ? 'fa-brands fa-' : 'mdi-') + icon
                return {icon, url}
            })
        }
    }

    export default SocialIcons
</script>
